import { Image, Message, Table, List, Checkbox, Segment } from 'semantic-ui-react';
import logo from '../../assets/logo.png';
import { useSelector, useDispatch } from 'react-redux';


const GberArt25 = () => {

    const dispatch = useDispatch();
    const projectState = useSelector(state => state.project);
    const displayError = (error, title, message) => {
        return (<Message negative><Message.Header>{title}</Message.Header>{message}</Message>);
    }

    const getProjectTitle = () => {
        let title = '';
        projectState.project.title.forEach(item => {
            if (item.translation !== '') {
                title = item.translation + ' - ' + item.language;
            }
            if (item.language === 'EN' && item.translation !== '') {
                title = item.translation;
            }
        });
        return (title);
    }

    const renderProjectDescription = () => {
        return (
            <Table celled>
                <Table.Body>
                    <Table.Row key="0-1">
                        <Table.Cell width="4">Project Number</Table.Cell>
                        <Table.Cell>{projectState.project.customIdentifier}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-2">
                        <Table.Cell >Project Acronym</Table.Cell>
                        <Table.Cell>{projectState.project.acronym}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-3">
                        <Table.Cell >Project Title</Table.Cell>
                        <Table.Cell>{getProjectTitle()}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-4">
                        <Table.Cell >Project Title</Table.Cell>
                        <Table.Cell>{getProjectTitle()}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-5">
                        <Table.Cell >Project Title</Table.Cell>
                        <Table.Cell>{getProjectTitle()}</Table.Cell>
                    </Table.Row>
                    <Table.Row key="0-6">
                        <Table.Cell >Project Title</Table.Cell>
                        <Table.Cell>{getProjectTitle()}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        );
    }

        return (
            <div className='margin-report-1'>
                <table>
                    <thead>
                        <tr>
                            <th><Image src={logo} size='medium' /></th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr className='page-break full-width'>
                            <td>
                                <h2 className='title'>Notification of state aid</h2>
                                {renderProjectDescription()}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    
}

export default GberArt25;